import React, { Fragment, useState } from "react";
import { ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { DropdownCommonProp } from "../../../../Types/UiKitsType";
import { Href } from "../../../../Constants/Constants";

const DividerBody: React.FC<DropdownCommonProp> = ({ item }) => {
  const [open, setOpen] = useState(false);
  return (
    <ButtonGroup>
      <Dropdown isOpen={open} toggle={() => setOpen(!open)} direction="down">
        <DropdownToggle caret className="rounded-pill" color={item.class}>
          {item.text}
        </DropdownToggle>
        <DropdownMenu className="dropdown-block">{item.menulist && item.menulist.map((item, index) => <Fragment key={index}>{item !== "" ? <DropdownItem href={Href}>{item}</DropdownItem> : <DropdownItem href={Href} divider></DropdownItem>}</Fragment>)}</DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};
export default DividerBody;
